import React from 'react';

import DealPageCol from '@/components/Table/DealPageCol';
import { EmptyBidCard } from '@/components/cards/EmptyBidCard';
import LicensedNft from '@/components/cards/LicensedNft';
import type { GetBrandByUsernameQuery } from '@/utilities/__generated__/graphql';

interface BidsProps {
  executed_bids: GetBrandByUsernameQuery['executed_bids'];
}

const LiscensedAssetsTable = ({ executed_bids }: BidsProps) => {
  return (
    <div className="col-span-2 flex flex-col-reverse gap-8 md:flex-row">
      <div className="w-full">
        <DealPageCol title="Licensed Assets">
          <div className="mx-4 w-full justify-self-center pb-6 pt-8 md:mx-6">
            {executed_bids?.length > 0 ? (
              <div className="hidden-scroll flex snap-x snap-mandatory space-x-4 overflow-scroll ">
                <div className="hidden-scroll flex w-full snap-x snap-mandatory gap-2 md:grid md:grid-cols-3 md:gap-4 md:overflow-scroll">
                  {executed_bids.map((data) => (
                    <div
                      key={`${data.token_id}${data.Deal.id}`}
                      className="col-span-1 snap-start"
                    >
                      <LicensedNft
                        tokenId={data.token_id}
                        collectionAddress={data.nft_contract_address}
                        tokenName={String(data.Collection.name)}
                        brand={data.Deal.Brand}
                        dealName={data.Deal.title}
                        dealId={data.Deal.id}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="flex w-full items-center justify-center">
                <EmptyBidCard hasButton={false} title={'No Licensed Assets'} />
              </div>
            )}
          </div>
        </DealPageCol>
      </div>
    </div>
  );
};

export default LiscensedAssetsTable;
